import {VehicleFinancingTemplateResponseBody} from '@dms/api/sales';
import {SaveSaleVehicleFinancingBody, VehicleFinancingType} from '@dms/api/vehicle';
import {INITIAL_BALLOON_BRACKET, RATE_MATRIX_TERMS} from '@dms/features/vehicle-financing-template';

const NEW_TEMPLATE_ID = '';
const DEFAULT_PAYMENT_STEP = 'TEN_PERCENT';

/**
 * Seeds a blank template from the vehicle's current financing configuration, so "create template"
 * on the vehicle detail starts from the values already on screen (bank, cost overrides, the terms
 * the matrix offers) instead of from global defaults. The rate cells are deliberately left empty —
 * the user picks the rates for the new template.
 */
export function createVehicleFinancingTemplateSeed(
  type: VehicleFinancingType,
  body: SaveSaleVehicleFinancingBody
): VehicleFinancingTemplateResponseBody {
  return {
    id: NEW_TEMPLATE_ID,
    name: '',
    validFrom: null,
    validTo: null,
    expirationAction: null,
    replacementTemplateId: null,
    type,
    interestRateType: body.interestRateTypeOverride ?? 'FIXED',
    financialInstitutionCodeId: body.financialInstitutionCodeId ?? '',
    processingFee: body.processingFeeOverride,
    vehicleTransferIncluded: body.vehicleTransferIncludedOverride ?? false,
    vehicleTransferAmount: body.vehicleTransferAmountOverride,
    vehicleRegistrationIncluded: body.vehicleRegistrationIncludedOverride ?? false,
    vehicleRegistrationAmount: body.vehicleRegistrationAmountOverride,
    vehicleDeliveryIncluded: body.vehicleDeliveryIncludedOverride ?? false,
    vehicleDeliveryAmount: body.vehicleDeliveryAmountOverride,
    tradeInPossible: body.tradeInPossibleOverride ?? false,
    creditProtectionAutoEnable: body.creditProtectionIncluded,
    scope: {
      mode: 'ALL_VEHICLES',
      branchIds: [],
      segment: {
        makes: [],
        models: [],
        vehicleCategories: [],
        fuelTypes: [],
        yearFrom: null,
        yearTo: null,
        mileageFrom: null,
        mileageTo: null,
        sellingPriceFrom: null,
        sellingPriceTo: null,
      },
    },
    downPaymentStep: DEFAULT_PAYMENT_STEP,
    balloonPaymentStep: type === 'BALLOON' ? DEFAULT_PAYMENT_STEP : null,
    defaultBalloonPayment: type === 'BALLOON' ? INITIAL_BALLOON_BRACKET : null,
    defaultTerm: null,
    defaultDownPayment: null,
    rateMatrix: {
      // The vehicle body types the terms as plain numbers; the template contract only accepts the
      // catalogue values, so the catalogue is the filter rather than a cast.
      availableTerms: RATE_MATRIX_TERMS.filter((term) =>
        body.rateMatrix.availableTerms.includes(term)
      ),
      cells: [],
    },
    archived: false,
    automatic: false,
    automaticPosition: null,
  };
}
